import { Component, OnInit } from '@angular/core';
import {AdminPlacementTestSelectionListService} from './admin-placement-test-selection-list.service';

@Component({
  selector: 'app-admin-placement-test-selection-list',
  templateUrl: './admin-placement-test-selection-list.component.html',
  styleUrls: ['./admin-placement-test-selection-list.component.css']
})
export class AdminPlacementTestSelectionListComponent implements OnInit {

  constructor(public selectionSv: AdminPlacementTestSelectionListService) { }

  ngOnInit() {
  }

}
